/**
 * Toggle elements height to display or hide
 */
export const toggleHeight = (element: HTMLElement) => {
  const isCurrentHeight =
    element.style.height === '0px' || element.style.height === '';

  if (isCurrentHeight) {
    // Set height to scrollHeight
    element.style.height = `${element.scrollHeight}px`;
  } else {
    // Reset height
    element.style.height = '0px';
  }
};
